module.exports = __webpack_public_path__ + "media/images/home/logo-ae-white-2505121044a97b9198b1a704cb50dc71.svg";